<template>
  <v-menu location="bottom start" :close-on-content-click="true" :disabled="readonly">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        :color="accent ? 'primary' : 'surface'"
        :variant="accent ? 'tonal' : 'flat'"
        rounded="pill"
        size="small"
        :append-icon="readonly ? undefined : 'mdi-chevron-down'"
        class="chip-select"
        :border="!accent"
      >
        <v-icon v-if="icon" :icon="icon" size="small" start />
        {{ modelValue || placeholder }}
      </v-btn>
    </template>

    <v-list density="compact" max-height="280" class="pa-1">
      <v-list-item
        v-for="opt in normalized"
        :key="opt.value"
        :active="opt.value === modelValue"
        rounded="md"
        @click="$emit('update:modelValue', opt.value)"
      >
        <v-list-item-title>{{ opt.value }}</v-list-item-title>
        <v-list-item-subtitle v-if="opt.sub">{{ opt.sub }}</v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import type { ChipOption } from '@/types/automations'

interface Opt {
  value: string
  sub?: string
}

@Options({
  props: {
    modelValue: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    icon: { type: String, default: '' },
    accent: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Choose…' },
    // Display-only chip: no dropdown, no chevron. Used where the value is informational.
    readonly: { type: Boolean, default: false }
  },
  emits: ['update:modelValue']
})
export default class ChipSelect extends Vue {
  modelValue!: string
  options!: ChipOption[]
  icon!: string
  accent!: boolean
  placeholder!: string
  readonly!: boolean

  get normalized(): Opt[] {
    return this.options.map((o) => (typeof o === 'string' ? { value: o } : o))
  }
}
</script>

<style scoped lang="scss">
.chip-select {
  text-transform: none;
  letter-spacing: normal;
  // Long agent/option names truncate inside the chip instead of blowing up the surrounding row.
  max-width: 280px;

  :deep(.v-btn__content) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
}
</style>
